<template>
	<div class="main" style="min-height: 500px; min-width: 500px" v-if="!isLoading">
		<div class="mr-2">
			<div class="mb-6">
				<div class="flex cursor-pointer justify-between" @click="showDownloadiOS = !showDownloadiOS">
					<div class="font-bold">
						{{ $t('ios') }}
					</div>
					<div>
						<font-awesome-icon :icon="['fas', showDownloadiOS ? 'angle-up' : 'angle-down']" />
					</div>
				</div>
				<div class="mt-4">
					<img src="../../../assets/qr-code-consumer-ios.svg" alt="QR Code Connect Consumer iOS" v-if="showDownloadiOS" class="h-128" />
				</div>
			</div>
			<div class="mb-6">
				<div class="flex justify-between cursor-pointer" @click="showDownloadAndroid = !showDownloadAndroid">
					<div class="font-bold">
						{{ $t('android') }}
					</div>
					<div>
						<font-awesome-icon :icon="['fas', showDownloadAndroid ? 'angle-up' : 'angle-down']" />
					</div>
				</div>
				<div class="mt-4">
					<img src="../../../assets/qr-code-consumer-android.svg" alt="QR Code Connect Consumer Android" v-if="showDownloadAndroid" class="h-128" />
				</div>
			</div>
			<div class="">
				<div class="flex justify-between cursor-pointer" @click="showConnectCustomerApp = !showConnectCustomerApp">
					<div class="font-bold">
						{{ $t('connection_customer_app') }}
					</div>
					<div>
						<font-awesome-icon :icon="['fas', showConnectCustomerApp ? 'angle-up' : 'angle-down']" />
					</div>
				</div>
				<div class="mt-4">
					<vue-qrcode v-if="showConnectCustomerApp" class="h-128" style="align-self: start" :value="getQrLink" :margin="0" />
				</div>
			</div>
		</div>
	</div>
	<LoadingSpinner v-else />
</template>

<script>
import Authentication from '@/mixins/Authentication';
import VueQrcode from 'vue-qrcode';
import { CustomersApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';

export default {
	name: 'QRModal',
	mixins: [Authentication],
	components: { LoadingSpinner, VueQrcode },
	data() {
		return {
			customer: null,
			isLoading: true,
			showDownloadiOS: false,
			showDownloadAndroid: false,
			showConnectCustomerApp: false,
		};
	},
	mounted() {
		if (!this.isUserAllowedInLevel5or6) {
			this.$emit('authNotAllowed');
		} else {
			this.getCustomer();
		}
	},
	methods: {
		getCustomer() {
			CustomersApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.customersIdGet(this.$route.params.customer)
				.then(response => {
					this.customer = response.data;
					this.isLoading = false;
				});
		},
	},
	computed: {
		getQrLink() {
			return 'imd-connect-app://id=' + this.customer.id + '&qrkey=' + this.customer.qrKey;
		},
	},
};
</script>

<style scoped></style>
